import Component from '../core/Component'
import throttle from 'lodash/throttle'
import Scroll from '../services/Scroll'
import EventBus from '../core/EventBus'
import enquire from 'enquire.js'
import { queries } from '../core/config'

export const STATES = {
    STICKY: 'is-sticky'
}

export default class Sticky extends Component {
    constructor(element) {
        super(element)

        this.options = {
            top: 70,
            stickTo: 'top'
        }

        const top = parseInt(this.element.dataset.stickyTop)
        const stickTo = this.element.dataset.stickTo

        if (!isNaN(top)) {
            this.options.top = top
        }

        if (stickTo) {
            this.options.stickTo = stickTo
        }

        this.isSticky = false

        this.handleScroll = ::this.handleScroll
        this.handleResize = throttle(::this.handleResize, 100)
        this.resize = ::this.resize

        this.enquireHandler = {
            match: () => this.match(),
            unmatch: () => this.unmatch()
        }
    }

    prepare() {
        this.parent = this.element.parentNode

        this.modal = this.element.closest('.Modal')

        if (this.modal) {
            this.modal = Component.getFromElement(this.modal)

            if (this.modal.options.scroll) {
                this.modalScrollbar = this.modal.scrollContainer.scrollbar
            }
        }

        if (this.options.stickTo == 'top') {
            this.element.style.paddingTop = this.options.top + 'px'
        } else if (this.options.stickTo == 'bottom') {
            this.element.style.paddingBottom = this.options.top + 'px'
        }

        if (this.modalScrollbar) {
            this.modalScrollbar.addListener(this.handleScroll)
            EventBus.on('modal:open', this.resize)
        } else {
            Scroll.on('scroll', this.handleScroll)
        }

        Scroll.on('resize', this.handleResize)
        EventBus.on('tabs:change', this.handleResize)
        EventBus.on('dropdown:changedHeight', this.handleContentChange)

        enquire.register(queries.smallMax, this.enquireHandler)

        this.resize()
        this.render()
    }

    destroy() {
        if (this.modalScrollbar) {
            this.modalScrollbar.removeListener(this.handleScroll)
            EventBus.off('modal:open', this.resize)
        } else {
            Scroll.off('scroll', this.handleScroll)
        }

        Scroll.off('resize', this.handleResize)
        EventBus.off('tabs:change', this.handleResize)
        EventBus.off('dropdown:changedHeight', this.handleContentChange)
        enquire.unregister(queries.smallMax, this.enquireHandler)
    }

    match = () => {
        if (this.modalScrollbar) {
            this.modalScrollbar.removeListener(this.handleScroll)
        } else {
            Scroll.off('scroll', this.handleScroll)
        }

        if (this.element.classList.contains(STATES.STICKY)) {
            this.element.classList.remove(STATES.STICKY)
            this.isSticky = false
            this.element.style.transform = 'translate3d(0,0px,0)'
        }
    }

    unmatch = () => {
        if (this.modalScrollbar) {
            this.modalScrollbar.addListener(this.handleScroll)
            EventBus.on('modal:open', this.resize)
        } else {
            Scroll.on('scroll', this.handleScroll)
        }

        this.render()
    }

    handleScroll() {
        this.render()
    }

    handleResize() {
        this.resize()
    }

    handleContentChange = () => {
        this.resize()
        this.render()
    }

    resize() {
        this.element.style.width = 'auto'

        const scrollTop = this.getScrollTop()

        const parentBox = this.parent.getBoundingClientRect()
        this.parentBox = {
            height: parentBox.height,
            width: parentBox.width,
            top: scrollTop + parentBox.top,
            bottom: scrollTop + parentBox.bottom
        }

        const elementBox = this.element.getBoundingClientRect()
        this.elementBox = {
            height: elementBox.height,
            width: elementBox.width,
            top: scrollTop + elementBox.top,
            bottom: scrollTop + elementBox.bottom
        }

        this.element.style.width = `${this.elementBox.width}px`

        if (this.options.stickTo == 'bottom') {
            this.element.style.transform = `translate3d(0,${scrollTop + window.innerHeight - this.options.top}px,0)`
        }
    }

    render() {
        if (this.disabled) {
            return
        }

        var offset = 0
        var max = this.parentBox.height - this.elementBox.height

        if (this.options.stickTo == 'top') {
            offset = this.getScrollTop() - this.parentBox.top + this.options.top
        } else if (this.options.stickTo == 'bottom') {
            offset = this.getScrollTop() + window.innerHeight - this.parentBox.top - this.options.top - this.elementBox.height
        }

        if (offset < 0) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.transform = 'translate3d(0,0px,0)'
            }
        } else if (offset > max) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.transform = `translate3d(0,${max}px,0)`
            }
        } else {
            if (!this.isSticky) {
                this.element.classList.add(STATES.STICKY)
                this.isSticky = true
            }
            this.element.style.transform = `translate3d(0,${offset}px,0)`
        }
    }

    getScrollTop() {
        if (this.modalScrollbar) {
            return this.modalScrollbar.scrollTop
        } else {
            return Scroll.getScroll().y
        }
    }
}